import { Typography, Grid2, Card, CardHeader, CardContent } from "@mui/material"
import { Box } from "@mui/material"

import { Icon } from "@iconify/react/dist/iconify.js"

import { fCurrency } from "../../../utils/formatNumbers"
import { makeStyles } from "@mui/styles"

const useStyles = makeStyles((theme) => ({
    cardHeader: {
        backgroundColor:
            theme.palette.type === "light"
                ? theme.palette.grey[200]
                : theme.palette.grey[700],
    },
}))

function PaymentDetails(props) {
    const classes = useStyles()
    const { formValues } = props

    const { plan } = formValues

    const newPlan = JSON.parse(plan)
    const { price } = newPlan

    return (
        <Grid2 size={{ xs: 12, sm: 12 }}>
            <Grid2
                key={newPlan.title}
                size={{
                    xs: 12,
                    md: 12,
                }}
            >
                <Card variant="outlined">
                    <CardHeader
                        title={newPlan.title}
                        subheader={newPlan.subheader}
                        titleTypographyProps={{ align: "center" }}
                        subheaderTypographyProps={{
                            align: "center",
                        }}
                        className={classes.cardHeader}
                    />
                    <CardContent>
                        <Box
                            display="flex"
                            alignItems="center"
                            flexDirection={"column"}
                            mt={2}
                        >
                            <Box display="flex" alignItems="center" gap={1}>
                                <Icon icon="healthicons:call-centre-outline" />
                                <Typography variant="body1">
                                    {newPlan.users} atendente
                                    {newPlan.users !== 1 && "s"}
                                </Typography>
                            </Box>
                            <Box display="flex" alignItems="center" gap={1}>
                                <Icon icon="heroicons:queue-list-solid" />
                                <Typography variant="body1">
                                    {newPlan.queues} filas
                                </Typography>
                            </Box>
                            <Box display="flex" alignItems="center" gap={1}>
                                <Icon icon="material-symbols:wifi" />
                                <Typography variant="body1">
                                    {newPlan.connections} conexões
                                </Typography>
                            </Box>
                        </Box>
                        <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            mt={2}
                        >
                            {newPlan.features.map(({ name, isEnabled }) => {
                                return (
                                    <Typography key={name}>
                                        {`${isEnabled ? "✔️" : "❌"} ${name}`}
                                    </Typography>
                                )
                            })}
                        </Box>
                    </CardContent>
                </Card>
            </Grid2>

            <Typography gutterBottom variant="h6" textAlign="right">
                Total: {fCurrency(price)}
            </Typography>
        </Grid2>
    )
}

export default PaymentDetails
